import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "py-3 container" }
const _hoisted_2 = {
  key: 1,
  class: "space-y-4 flex flex-col justify-center"
}
const _hoisted_3 = { class: "text-lg font-semibold" }
const _hoisted_4 = { class: "w-full py-3 justify-center" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex flex-col shadow-md px-10 py-10 mb-2 rounded-2xl justify-center w-full" }
const _hoisted_7 = { class: "w-full flex flex-row items-center space-x-5" }
const _hoisted_8 = { class: "flex flex-row w-9/12 items-center space-x-5" }
const _hoisted_9 = { class: "text-lg semibold" }
const _hoisted_10 = { class: "flex flex-row w-3/12 items-center justify-end" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-gray-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
  })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "w-full flex-row mt-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "my-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, [
    /*#__PURE__*/_createTextVNode("Title "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
  ])
], -1)
const _hoisted_16 = { class: "w-full flex-row mt-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "my-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, [
    /*#__PURE__*/_createTextVNode("URL "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-orange-400" }, "(Required)")
  ])
], -1)
const _hoisted_18 = { class: "w-full flex flex-row mt-6 justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Skeleton, {
          key: 0,
          option: "card"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.jobChallengeData.id !== null
            ? "Code challenge"
            : "Assign code challenge"), 1),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.jobChallengeData.id !== null && !_ctx.isEditing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_Avatar, {
                          name: _ctx.jobChallengeData.title
                        }, null, 8, ["name"]),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.jobChallengeData.title), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editJobChallenge(_ctx.jobChallengeData))),
                          class: "text-red-500"
                        }, _hoisted_12)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("form", null, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_TextField, {
                        label: "",
                        placeholder: "e.g. Vue",
                        typeInput: "text",
                        name: "title",
                        floatingInput: true
                      })
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_TextField, {
                        label: "",
                        placeholder: "e.g. https://mycodechallenge.com",
                        typeInput: "text",
                        name: "challenge_url",
                        floatingInput: true
                      })
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_Button, {
                        variant: "contained",
                        label: `Save`,
                        onClick: _ctx.onSubmit,
                        disabled: !_ctx.meta.valid
                      }, null, 8, ["onClick", "disabled"])
                    ])
                  ])
                ]))
          ])
        ]))
  ]))
}